<div class="card h-100">
  <div class="card-body">
    @if (views.length) {
      <table class="table">
        <thead>
          <tr>
            <td>Type</td>
            <td>View</td>
            <td>Type Of View</td>
            <td>View 2</td>
            <td class="text-end">Value</td>
            <td>Confidence</td>
            <td>Frequency</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (c of views; track c.id) {
            <tr [hidden]="c.id == activeView.id">
              <td>{{ getTypeName(c.type) }}</td>
              <td>
                @for (d of c.items; track d.id) {
                  <span
                    class="m-0 p-0"
                    [matTooltip]="d.name_full ?? ''"
                    matTooltipPosition="right"
                    >{{ d.name_short ?? d.name }}</span
                  >
                }
              </td>
              <td class="text-capitalize">{{ c.view_type | cleanName }}</td>
              <td>
                @for (d of c.items2; track d.id) {
                  <span class="m-0 p-0 d-block">{{
                    d.name_short ?? d.name
                  }}</span>
                }
              </td>
              <td class="text-end pe-4 number-col">{{ c.value }}%</td>
              <td class="pe-4 number-col">
                {{ c.confidence | confidenceLabel }}
              </td>
              <td class="text-capitalize">{{ c.frequency }}</td>
              <td>
                <mat-icon
                  class="cursor-pointer text-primary"
                  (click)="editView(c)"
                  >edit</mat-icon
                >
                <mat-icon
                  class="cursor-pointer text-danger"
                  (click)="deleteView(c)"
                  >delete</mat-icon
                >
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (activeView.type) {
      <div class="view-form pt-3">
        <!-- Row 1: Type (locked), View, View Type (locked), Frequency (auto) -->
        <div class="row g-3">
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Type</mat-label>
              <mat-select
                [(ngModel)]="activeView.type"
                required
                placeholder="Type"
                disabled
              >
                @for (i of types; track i.id) {
                  <mat-option [value]="i.id">{{ i.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <app-benchmark-selector-for-views
              [selectedBenchmark]="activeView.items"
              (benchmarkSelect)="onBenchmarkSelected($event)"
              [isFullWidth]="true"
              benchmarkPlaceholder="Select macro"
            ></app-benchmark-selector-for-views>
            @if (formSubmitted && !activeView.items) {
              <mat-error>View is required</mat-error>
            }
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>View Type</mat-label>
              <mat-select
                [(ngModel)]="activeView.view_type"
                required
                placeholder="View Type"
                disabled
              >
                @for (i of viewTypes; track i.id) {
                  <mat-option [value]="i.id">{{ i.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Frequency</mat-label>
              <input
                matInput
                [value]="
                  activeView.frequency ? (activeView.frequency | titlecase) : ''
                "
                placeholder="Auto from selected macro"
                disabled
              />
              <mat-hint
                >This is the highest frequency available for this macro
                factor.</mat-hint
              >
            </mat-form-field>
          </div>
        </div>
        <!-- Row 2: Value, Confidence -->
        <div class="row g-3 align-items-center">
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Value</mat-label>
              <input
                matInput
                [(ngModel)]="activeView.value"
                required
                type="number"
              />
              <span matSuffix>%</span>
              <mat-error>Value is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            @if (confidenceSelectValue !== "custom") {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Confidence</mat-label>
                <mat-select
                  [(ngModel)]="confidenceSelectValue"
                  required
                  (ngModelChange)="onConfidenceSelectChange($event)"
                  placeholder="Confidence"
                >
                  @for (c of confidenceLevels; track c.value) {
                    <mat-option [value]="c.value">{{ c.label }}</mat-option>
                  }
                </mat-select>
                <mat-error>Confidence is required</mat-error>
              </mat-form-field>
            }
            @if (confidenceSelectValue === "custom") {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Confidence</mat-label>
                <input
                  matInput
                  [(ngModel)]="activeView.confidence"
                  required
                  type="number"
                  min="0"
                  max="100"
                  placeholder="0–100"
                />
                <span matSuffix class="d-flex align-items-center gap-1">
                  <span>%</span>
                  <mat-icon
                    class="cursor-pointer text-muted"
                    style="font-size: 18px; line-height: 18px"
                    (click)="
                      confidenceSelectValue = null; activeView.confidence = null
                    "
                    matTooltip="Back to presets"
                    >close</mat-icon
                  >
                </span>
                <mat-error>Confidence is required</mat-error>
              </mat-form-field>
            }
          </div>
          <div class="col-12 text-end mb-2">
            <button mat-button (click)="saveView()" color="primary">
              <mat-icon>save</mat-icon> Save
            </button>
            <button mat-button (click)="discardView()">
              <mat-icon>close</mat-icon> Close
            </button>
          </div>
        </div>
      </div>
    }

    @if (!activeView.type) {
      <div class="text-center">
        <button mat-flat-button color="primary" (click)="onAddView()">
          <span class="navigation-button">+ Add view</span>
        </button>
      </div>
    }
  </div>
</div>
